import { Action } from '@ngrx/store';
import { EmployeeModel } from "../../models/employee.model";
import { CustomerModel } from "../../models/customer.model";
import { BillingInformationModel } from '../../models/billingInformation.model';

export const LOGIN_START = '[Auth] Login Start';
export const LOGIN_SUCCESS = '[Auth] Login Success';
export const LOGIN_FAIL = '[Auth] Login Fail';
export const LOGOUT = '[Auth] Logout';
export const AUTOLOGIN = '[Auth] Autologin';

export const REGISTER_START = '[Auth] Register Start';
export const REGISTER_SUCCESS = '[Auth] Register Success';
export const REGISTER_FAIL = '[Auth] Register Fail';

export const FORGOT_PASSWORD_START = '[Auth] Forgot Password Start';
export const FORGOT_PASSWORD_SUCCESS = '[Auth] Forgot Password Success';
export const FORGOT_PASSWORD_FAIL = '[Auth] Forgot Password Fail';

export const RESET_PASSWORD_START = '[Auth] Reset Password Start';
export const RESET_PASSWORD_SUCCESS = '[Auth] Reset Password Success';
export const RESET_PASSWORD_FAIL = '[Auth] Reset Password Fail';

export const LOGIN_LINK = '[Auth] Send Login Link To Email';
export const LOGIN_LINK_SENT = '[Auth] Login Link Sent To Email';

export const SIGNUP_START = '[Auth] Signup Start';
export const SIGNUP_CODE_SENT = '[Auth] Signup Registration Code Sent';
export const SIGNUP_CODE = '[Auth] Signup Registration Code';

export const CHANGE_PASSWORD = '[Auth] Change Password';
export const CHANGE_PASSWORD_SUCCESS = '[Auth] Change Password Success';
export const CHANGE_PASSWORD_FAILED = '[Auth] Change Password Failed';

export const UPDATE_PROFILE = '[Auth] Update Profile';
export const UPDATE_PROFILE_SUCCESS = '[Auth] Update Profile Success';
export const UPDATE_PROFILE_FAILED = '[Auth] Update Profile Failed';

export const VERIFY_NEW_EMAIL = '[Auth] Verify New Email';
export const VERIFY_NEW_EMAIL_SUCCESS = '[Auth] Verify New Email Success';
export const UPDATE_EMAIL = '[Auth] Update Email';

export const CREATE_CUSTOMER = '[Auth] Create New Customer';
export const CREATE_CUSTOMER_SUCCESS = '[Auth] Create New Customer Success';
export const CREATE_CUSTOMER_FAILED = '[Auth] Create New Customer Failed';

export const UPDATE_CUSTOMER = '[Auth] Update Customer';
export const UPDATE_CUSTOMER_SUCCESS = '[Auth] Update Customer Success';
export const UPDATE_CUSTOMER_FAILED = '[Auth] Update Customer Failed';

export const UPDATE_CUSTOMER_ORGANISATION_NUMBER = '[Auth] Update Customer Organisation Number';
export const UPDATE_CUSTOMER_ORGANISATION_NUMBER_SUCCESS = '[Auth] Update Customer Organisation Number Success';
export const UPDATE_CUSTOMER_ORGANISATION_NUMBER_FAILED = '[Auth] Update Customer Organisation Number Failed';

export const SET_INVITE_TOKEN = '[Auth] Set Invite Token';
export const CLEAR_INVITE_TOKEN = '[Auth] Clear Invite Token';

export const TRANSFER_OWNERSHIP = '[Auth] Transfer Ownership';

export const SWITCH_COMPANY_ACCOUNT = '[Auth] Switch Company Account';

export const UPDATE_BILLING_INFO = '[Company] Update Billing Information For Company';
export const UPDATE_BILLING_INFO_SUCCESS = '[Company] Update Billing Information For Company Success';
export const UPDATE_BILLING_INFO_FAILED = '[Company] Update Billing Information For Company Failed';

export const CREATE_BILLING_INFO = '[Company] Create Billing Information For Company';
export const CREATE_BILLING_INFO_SUCCESS = '[Company] Create Billing Information For Company Success';
export const CREATE_BILLING_INFO_FAILED = '[Company] Create Billing Information For Company Failed';

export const STORE_JOB_PLACE_BILLING_INFO = '[Auth] Store Job Place Billing Info';
export const STORE_JOB_PLACE_BILLING_INFO_SUCCESS = '[Auth] Store Job Place Billing Info Success';
export const STORE_JOB_PLACE_BILLING_INFO_FAILED = '[Auth] Store Job Place Billing Info Failed';

// BankID Actions
export const BANKID_AUTH_START = '[Auth] BankID Auth Start';
export const BANKID_AUTH_SUCCESS = '[Auth] BankID Auth Success';
export const BANKID_AUTH_FAIL = '[Auth] BankID Auth Fail';

export const BANKID_COLLECT_PROGRESS = '[Auth] BankID Collect Progress';
export const BANKID_COLLECT_COMPLETE = '[Auth] BankID Collect Complete';
export const BANKID_COLLECT_FAIL = '[Auth] BankID Collect Fail';
export const BANKID_AUTH_CLEAR = '[Auth] BankID Auth Clear';


export class SignupStart implements Action {
    readonly type = SIGNUP_START;
    constructor(public payload: { email: string }) {}
}

export class SignupCodeSent implements Action {
    readonly type = SIGNUP_CODE_SENT;
}

export class SignupCode implements Action {
    readonly type = SIGNUP_CODE;
    constructor(public payload: { code: number }) {}
}

export class SendLoginLink implements Action {
    readonly type = LOGIN_LINK;
    constructor(public payload: { email: string }) {}
}

export class LoginLinkSent implements Action {
    readonly type = LOGIN_LINK_SENT;
}

export class LoginStart implements Action {
    readonly type = LOGIN_START;
    constructor(public payload: { email: string, password: string }) {}
}

export class LoginSuccess implements Action {
    readonly type = LOGIN_SUCCESS;
    constructor(public payload: { employee: EmployeeModel, jwt: any }) {}
}

export class LoginFailed implements Action {
    readonly type = LOGIN_FAIL;
}

export class Autologin implements Action {
    readonly type = AUTOLOGIN;
}

export class Logout implements Action {
    readonly type = LOGOUT;
}

export class RegisterStart implements Action {
    readonly type = REGISTER_START;
    constructor(public payload: { email: string, password: string, confirmPassword: string }) {}
}

export class RegisterSuccess implements Action {
    readonly type = REGISTER_SUCCESS;
    constructor(public payload: { employee: EmployeeModel, jwt: any }) {}
}

export class RegisterFailed implements Action {
    readonly type = REGISTER_FAIL;
}

export class ForgotPasswordStart implements Action {
    readonly type = FORGOT_PASSWORD_START;
    constructor(public payload: { email: string }) {}
}

export class ForgotPasswordSuccess implements Action {
    readonly type = FORGOT_PASSWORD_SUCCESS;
    constructor(public payload: { message: string }) {}
}

export class ForgotPasswordFailed implements Action {
    readonly type = FORGOT_PASSWORD_FAIL;
}

export class ResetPasswordStart implements Action {
    readonly type = RESET_PASSWORD_START;
    constructor(public payload: { token: string, password: string, confirmPassword: string }) {}
}

export class ResetPasswordSuccess implements Action {
    readonly type = RESET_PASSWORD_SUCCESS;
    constructor(public payload: { message: string }) {}
}

export class ResetPasswordFailed implements Action {
    readonly type = RESET_PASSWORD_FAIL;
}

export class ChangePassword implements Action {
    readonly type = CHANGE_PASSWORD;
    constructor(public payload: { employeeId: number, oldPassword: string, password: string, confirmPassword: string }) {}
}

export class ChangePasswordSuccess implements Action {
    readonly type = CHANGE_PASSWORD_SUCCESS;
    constructor(public payload: { employee: EmployeeModel }) {}
}

export class ChangePasswordFailed implements Action {
    readonly type = CHANGE_PASSWORD_FAILED;
}

export class UpdateProfile implements Action {
    readonly type = UPDATE_PROFILE;
    constructor(public payload: { employeeId: number, locale?: string, firstName?: string, lastName?: string, email?: string, phone?: string, avatar?: File }) {}
}

export class UpdateProfileSuccess implements Action {
    readonly type = UPDATE_PROFILE_SUCCESS;
    constructor(public payload: { employee: EmployeeModel }) {}
}

export class UpdateProfileFailed implements Action {
    readonly type = UPDATE_PROFILE_FAILED;
}

export class VerifyNewEmail implements Action {
    readonly type = VERIFY_NEW_EMAIL;
    constructor(public payload: { employeeId: number, email: string }) {}
}

export class VerifyNewEmailSuccess implements Action {
    readonly type = VERIFY_NEW_EMAIL_SUCCESS;
}

export class UpdateEmail implements Action {
    readonly type = UPDATE_EMAIL;
    constructor(public payload: { employeeId: number, token: string, password: string, confirmPassword: string }) {}
}

export class CreateCustomer implements Action {
    readonly type = CREATE_CUSTOMER;
    constructor(public payload: FormData) {}
}

export class CreateCustomerSuccess implements Action {
    readonly type = CREATE_CUSTOMER_SUCCESS;
    constructor(public payload: { customer: CustomerModel }) {}
}

export class CreateCustomerFailed implements Action {
    readonly type = CREATE_CUSTOMER_FAILED;
}

export class UpdateCustomer implements Action {
    readonly type = UPDATE_CUSTOMER;
    constructor(public payload: { customerId: number, inviteToken?: 'activate' | 'deactivate' }) {}
}

export class UpdateCustomerSuccess implements Action {
    readonly type = UPDATE_CUSTOMER_SUCCESS;
    constructor(public payload: { customer: CustomerModel }) {}
}

export class UpdateCustomerFailed implements Action {
    readonly type = UPDATE_CUSTOMER_FAILED;
}

export class UpdateCustomerOrganisationNumber implements Action {
    readonly type = UPDATE_CUSTOMER_ORGANISATION_NUMBER;
    constructor(public payload: {
        customerId: number;
        organisationNumber: string;
        isAutoCreatedFromRegistration?: boolean;
        companyName?: string;
        contactPerson?: string;
        email?: string;
        phone?: string;
        address?: string;
        city?: string;
        country?: string;
        biography?: string;
        customerWebsite?: string;
    }) {}
}

export class UpdateCustomerOrganisationNumberSuccess implements Action {
    readonly type = UPDATE_CUSTOMER_ORGANISATION_NUMBER_SUCCESS;
    constructor(public payload: { customer: CustomerModel }) {}
}

export class UpdateCustomerOrganisationNumberFailed implements Action {
    readonly type = UPDATE_CUSTOMER_ORGANISATION_NUMBER_FAILED;
}

export class SwitchCompanyAccount implements Action {
    readonly type = SWITCH_COMPANY_ACCOUNT;
    constructor(public payload: { customer: CustomerModel }) {}
}

export class SetInviteToken implements Action {
    readonly type = SET_INVITE_TOKEN;
    constructor(public payload: { inviteToken: string }) {}
}

export class ClearInviteToken implements Action {
    readonly type = CLEAR_INVITE_TOKEN;
}

export class TransferOwnership implements Action {
    readonly type = TRANSFER_OWNERSHIP;
}

export class UpdateBillingInfo implements Action {
    readonly type = UPDATE_BILLING_INFO;
    constructor(public payload: { customerId: number, billingId: number, data: any }) {}
}

export class UpdateBillingInfoSuccess implements Action {
    readonly type = UPDATE_BILLING_INFO_SUCCESS;
    constructor(public payload: { billing: BillingInformationModel }) {}
}

export class UpdateBillingInfoFailed implements Action {
    readonly type = UPDATE_BILLING_INFO_FAILED;
}

export class CreateBillingInfo implements Action {
    readonly type = CREATE_BILLING_INFO;
    constructor(public payload: {
        customerId: number,
        companyName: string,
        companyNumber: string,
        address: string,
        addressSecond?: string,
        postalCode?: string,
        city?: string,
        contactName: string,
        phone: string,
        email: string
    }) {}
}

export class StoreJobPlaceBillingInfo implements Action {
    readonly type = STORE_JOB_PLACE_BILLING_INFO;
    constructor(public payload: {
        customerId: number,
        jobPlaceId: number,
        payment_method: string,
        billing_reference: string,
        invoice_time: string,
        invoice_email?: string
    }) {}
}

export class StoreJobPlaceBillingInfoSuccess implements Action {
    readonly type = STORE_JOB_PLACE_BILLING_INFO_SUCCESS;
}

export class StoreJobPlaceBillingInfoFailed implements Action {
    readonly type = STORE_JOB_PLACE_BILLING_INFO_FAILED;
}

export class CreateBillingInfoSuccess implements Action {
    readonly type = CREATE_BILLING_INFO_SUCCESS;
    constructor(public payload: { billing: BillingInformationModel }) {}
}

export class CreateBillingInfoFailed implements Action {
    readonly type = CREATE_BILLING_INFO_FAILED;
}

export class BankIdAuthStart implements Action {
    readonly type = BANKID_AUTH_START;
}

export class BankIdAuthSuccess implements Action {
    readonly type = BANKID_AUTH_SUCCESS;
    constructor(public payload: { orderRef: string; qrStartToken: string; qrStartSecret: string; qrAutoStartToken: string }) {}
}

export class BankIdAuthFail implements Action {
    readonly type = BANKID_AUTH_FAIL;
    constructor(public payload: string) {}
}

// Updated BankID Collect Actions
export class BankIdCollectProgress implements Action {
    readonly type = BANKID_COLLECT_PROGRESS;
    constructor(public payload: string) {} // e.g., 'outstandingTransaction', 'pending'
}

export class BankIdCollectComplete implements Action {
    readonly type = BANKID_COLLECT_COMPLETE;
    constructor(public payload: { status: string; userDetails: any }) {}
}

export class BankIdCollectFail implements Action {
    readonly type = BANKID_COLLECT_FAIL;
    constructor(public payload: string) {} // Error message
}

export class BankIdAuthClear implements Action {
    readonly type = BANKID_AUTH_CLEAR;
}


export type AuthActions = 
    // Signup Actions
    | SignupStart
    | SignupCodeSent
    | SignupCode
    // Login Actions
    | SendLoginLink
    | LoginLinkSent
    | LoginStart
    | LoginSuccess
    | LoginFailed
    | Autologin
    | Logout
    // Register Actions
    | RegisterStart
    | RegisterSuccess
    | RegisterFailed
    // Password Actions
    | ForgotPasswordStart
    | ForgotPasswordSuccess
    | ForgotPasswordFailed
    | ResetPasswordStart
    | ResetPasswordSuccess
    | ResetPasswordFailed
    | ChangePassword
    | ChangePasswordSuccess
    | ChangePasswordFailed
    // Profile Actions
    | UpdateProfile
    | UpdateProfileSuccess
    | UpdateProfileFailed
    | VerifyNewEmail
    | VerifyNewEmailSuccess
    | UpdateEmail
    // Customer Actions
    | CreateCustomer
    | CreateCustomerSuccess
    | CreateCustomerFailed
    | UpdateCustomer
    | UpdateCustomerSuccess
    | UpdateCustomerFailed
    | UpdateCustomerOrganisationNumber
    | UpdateCustomerOrganisationNumberSuccess
    | UpdateCustomerOrganisationNumberFailed
    | SwitchCompanyAccount
    // Invite Token Actions
    | SetInviteToken
    | ClearInviteToken
    // Transfer Ownership
    | TransferOwnership
    // Billing Actions
    | UpdateBillingInfo
    | UpdateBillingInfoSuccess
    | UpdateBillingInfoFailed
    | CreateBillingInfo
    | CreateBillingInfoSuccess
    | CreateBillingInfoFailed
    | StoreJobPlaceBillingInfo
    | StoreJobPlaceBillingInfoSuccess
    | StoreJobPlaceBillingInfoFailed
    // BankID Actions
    | BankIdAuthStart
    | BankIdAuthSuccess
    | BankIdAuthFail
    | BankIdCollectProgress
    | BankIdCollectComplete
    | BankIdCollectFail
    | BankIdAuthClear;
